import React from "react";
import help from "../../../img/undraw_pay_online_re_aqe6.svg";
import { Fade } from "react-awesome-reveal";
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useState } from "react";
import "./subscribepackage.css";
import { Spinner } from "react-bootstrap";
import { useEffect } from "react";
import notify from "../../Notifcation";
import { useDispatch, useSelector } from "react-redux";
import {
  GetQouteDashAction,
  UpdateQuoteAction,
} from "../../../redux/actions/UserSubscriptionAction";
import { ToastContainer } from "react-toastify";
const Subscribepackage = () => {
  const [Year, setYear] = useState("");
  const [Month, setMonth] = useState("");
  const [PriceOneGiga, setPriceOneGiga] = useState("");
  const [loading, setLoading] = useState(true);
  const [isPress, setIsPress] = useState(false);
  const AllQo = useSelector((state) => state.UserSubscriptionR.GetQoutsdash);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(GetQouteDashAction());
  }, []);
  useEffect(() => {
    if (AllQo) {
      setMonth(AllQo.pricePerMonth);
      setYear(AllQo.pricePerYear);
      setPriceOneGiga(AllQo.pricePerGB);
    }
  }, [AllQo]);
  const handlesubmit = async (e) => {
    e.preventDefault();
    if (Year === null || PriceOneGiga === null || Month === null) {
      notify("من فضلك اكمل البيانات المطلوبة", "error");
      return;
    }
    setIsPress(true);
    setLoading(true);
    await dispatch(
      UpdateQuoteAction({
        id: 3,
        quoteName: "أعمال الموارد البشرية",
        pricePerMonth: Month,
        pricePerYear: Year,
        pricePerGB: PriceOneGiga,
      })
    );
    setLoading(false);
    setIsPress(false);
  };
  const res = useSelector((state) => state.UserSubscriptionR.Updatesqoute);
  useEffect(() => {
    if (loading === false) {
      if (res) {
        if (res.data.responseMessage === "Quote updated successfuly") {
          notify("تم التعديل بنجاح", "success");
        }
      } else {
        notify("الرجاء حاول مرة اخرى", "error");
      }
    }
  }, [loading]);
  return (
    <div className="subpackage">
      <div className="container rounded bg-white mt-5 mb-5">
        <div className="row">
          <div className="col-md-6 border-right">
            <div className="p-3 py-5">
              <div className="d-flex justify-content-between align-items-center mb-3">
                <h4 className="text-center">نوع الأشتراك</h4>
              </div>

              <div className="col-md-12  de mb-2">
                {" "}
                <TextField
                  focused
                  label="كود البرنامج"
                  variant="outlined"
                  value={3}
                />
              </div>
              <div className="col-md-12 de mb-2">
                {" "}
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      اسم البرنامج
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  </InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    value={1}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        اسم البرنامج
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }>
                    <MenuItem value={1}>أعمال الموارد البشرية </MenuItem>
                  </Select>
                </FormControl>
              </div>
              <div className="row ">
                <div className="col-md-6 de mb-2 ">
                  <TextField
                    style={{ width: "40%" }}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        شهر
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    focused
                    value={Month}
                    onChange={(e) => setMonth(e.target.value)}
                    variant="outlined"
                    inputProps={{ maxLength: 15 }}
                    type="number"
                  />
                </div>
                <div className="col-md-6 de ">
                  <TextField
                    style={{ width: "40%" }}
                    focused
                    value={Year}
                    onChange={(e) => setYear(e.target.value)}
                    label={
                      <Typography
                        sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                        سنة
                        <span style={{ color: "red", fontSize: "19px" }}>
                          *
                        </span>
                      </Typography>
                    }
                    variant="outlined"
                    inputProps={{ maxLength: 15 }}
                    type="number"
                  />
                </div>
              </div>
              <div className="col-md-12 de mb-2">
                {" "}
                <TextField
                  label={
                    <Typography
                      sx={{ fontSize: "18px", fontFamily: "Almarai" }}>
                      قيمة 1 GB
                      <span style={{ color: "red", fontSize: "19px" }}>*</span>
                    </Typography>
                  }
                  focused
                  value={PriceOneGiga}
                  onChange={(e) => setPriceOneGiga(e.target.value)}
                  variant="outlined"
                  inputProps={{ maxLength: 15 }}
                  type="number"
                />
              </div>
              {/* <div className="col-md-12 de ">
                  {" "}
                  <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">ميجا</InputLabel>
                    <Select
                      labelId="demo-simple-select-label"
                        
                      label="ميجا"
                      // onChange={handleChange}
                    >
                      <MenuItem value="200mb">200mb</MenuItem>
                      <MenuItem value="1GB">1GB</MenuItem>
                      <MenuItem value="2GB">2GB</MenuItem>
                      <MenuItem value="3GB">3GB</MenuItem>
                    </Select>
                  </FormControl>
                </div> */}
              {/* <div className="row ">
                  <div className="col-md-12 ">
                    {" "}
                    <div className="input-check">
                      {" "}
                      مفعل
                      <input type="checkbox" />
                    </div>
                  </div>
                </div> */}

              <div className="mt-5 text-center">
                {isPress && loading ? (
                  <button className="buttonadd" type="button">
                    <Spinner />
                  </button>
                ) : (
                  <button
                    onClick={handlesubmit}
                    className="buttonadd"
                    type="button">
                    تعديل
                  </button>
                )}
              </div>
            </div>
          </div>
          <div className="col-md-6">
            <Fade direction="left">
              <div className="p-3 py-5">
                <Fade direction="right">
                  <div className="d-flex flex-column align-items-center text-center p-3 py-5">
                    <img
                      className="mt-5"
                      width="150px"
                      src={help}
                      alt="avatar"
                    />
                  </div>
                </Fade>
              </div>
            </Fade>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={1200} />
    </div>
  );
};

export default Subscribepackage;
